import React, { } from 'react';
import { RouteChildrenProps, } from 'react-router-dom';
import { Modal, message, Spin, Button, Tag, Space } from 'antd';
import api, { GetAssetRes, GetAssetListParameters, DeleteAssetParameters } from '../../api';
import JJ_Table from '../../components/JJ_Table';
import AssetEditAndAdd, { Type } from './AssetAdd';
import { connect, ConnectedProps } from 'react-redux';
import { getAssetColumns, AssetColumnData } from '../../table-columns/Asset';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ActionUserRes } from '../../actions/ActionUser';
import tool from '../../tool';
import { PlusOutlined } from '@ant-design/icons';
import { TableProps } from 'antd/lib/table';

const { confirm } = Modal;

type EditAndAddModalType = Type

interface PageState {
  initLoading: boolean
  isSpinLoading: boolean
  editAndAddModal: {
    show: boolean
    key?: string
  } & EditAndAddModalType
}
interface Props {
  tableProps?: TableProps<GetAssetRes>
  category?: GetAssetListParameters['category']
}


interface Page {
  tableRef?: JJ_Table<GetAssetRes> | null
}


type PageProps = Props & ConnectedProps<typeof connector>

interface RootState {
  user: ActionUserRes
}

const mapState = (state: RootState) => ({
  user: state.user,

})

const mapDispatch = {

}

const connector = connect(
  mapState,
  mapDispatch
)

class AssetList extends React.Component<PageProps, PageState> implements Page {

  constructor (props: Readonly<PageProps>) {
    super(props);
    this.state = {
      isSpinLoading: true,
      initLoading: true,
      editAndAddModal: {
        type: 'add',
        show: false,
        key: new Date().toString()
      }
    }
  }
  tableRef?: JJ_Table<AssetColumnData> | null
  componentDidMount() {
    this._initData()
  }


  _getAssetList = async (params: GetAssetListParameters) => {
    const res = await api.GetAssetList(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  _deleteAsset = async (params: DeleteAssetParameters) => {
    const res = await api.DeleteAsset(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }


  _initData = async () => {
    try {
      this.setState({
        isSpinLoading: true,
        initLoading: true
      })

      this.setState({
        isSpinLoading: false,
        initLoading: false,
      })
    } catch (error:any) {
      this.setState({
        isSpinLoading: false,
        initLoading: false
      })
    }
  }
  render() {

    return (
      <div id="AssetList"
      >
        <Modal
          maskClosable={false}
          title={this.state.editAndAddModal.type === 'edit' ? '編輯素材' : '新建素材'}
          visible={this.state.editAndAddModal.show}
          footer={null}
          onCancel={() => this.setState(state => ({
            editAndAddModal: { ...state.editAndAddModal, show: false }
          }))}
          width={'85%'}
        >
          {this.state.editAndAddModal.key && (
            <AssetEditAndAdd
              {...this.state.editAndAddModal}
              onFinish={async (props) => {
                this.setState(state => ({
                  editAndAddModal: { ...state.editAndAddModal, show: false }
                }))
                switch (props.type) {
                  case 'add': {
                    this.tableRef && await this.tableRef.refreshData()
                    message.success(`添加成功`)
                  }
                    break
                  case 'edit': {
                    this.tableRef && await this.tableRef.refreshData()
                    message.success(`編輯成功`)
                  }
                }

              }}
            />
          )}

        </Modal>

        <Space>

          <Button
            type='primary'
            style={{ marginBottom: 5 }}
            onClick={() => {
              this.setState(state => ({
                editAndAddModal: {
                  ...state.editAndAddModal,
                  show: true,
                  key: new Date().toString(),
                  type: 'add',
                  category: this.props.category,
                }
              }))
            }}
            icon={<PlusOutlined />}
          >
            {`添加素材`}
          </Button>

        </Space>


        <Spin spinning={this.state.initLoading}>
          {!this.state.initLoading && (
            <Spin spinning={this.state.isSpinLoading}>

              <JJ_Table<AssetColumnData, {
                order?: 'ASC' | 'DESC'
                category?: GetAssetListParameters['category']
              }>
                ref={ref => this.tableRef = ref}
                isSearchText={true}
                sourceItems={[
                  {
                    type: 'select',
                    defaultValue: 'DESC',
                    key: 'order',
                    span: 4,
                    options: [
                      {
                        value: 'ASC',
                        name: '升序',
                        disabled: false,
                      },
                      {
                        value: 'DESC',
                        name: '降序',
                        disabled: false,
                      },
                    ]
                  },
                  {
                    type: 'select',
                    defaultValue: this.props.category,
                    placeholder: '任意類別',
                    allowClear: true,
                    key: 'category',
                    span: 8,
                    options: [
                      {
                        name: '活動頭像',
                        value: 'CAMPAIGN_AVATAR'
                      },
                      {
                        name: '活動照片',
                        value: 'CAMPAIGN_PHOTO'
                      },
                      {
                        name: '活動圖片',
                        value: 'ADVERTISEMENT'
                      },
                    ].map((item) => {
                      return ({
                        value: item.value,
                        name: item.name,
                        disabled: false,
                      })
                    })
                  },
                ]}
                columns={getAssetColumns({
                  onAction: (key, record) => {
                    switch (key) {

                      case 'delete': {
                        const name = record.id
                        confirm({
                          title: `是否刪除(${name})`,
                          icon: <ExclamationCircleOutlined />,
                          okText: 'Yes',
                          okType: 'danger',
                          cancelText: 'No',
                          onOk: async () => {
                            try {
                              await this._deleteAsset({ id: record.id })
                              this.tableRef && this.tableRef.refreshData()
                              message.success(`${name} 删除成功`)
                            } catch (error:any) {
                              message.error(`${name} 删除失败 [${error?.message}]`);
                            }
                          },
                          onCancel() {
                          },
                        });
                      }
                        break
                    }
                  }
                })}
                title={'素材列表'}
                tableProps={{
                  ...this.props.tableProps,
                  scroll: {
                    x: getAssetColumns().reduce((pv, cv) => pv + (Number(cv.width || 0)), 0),
                  }
                }}
                onDataSource={async (body) => {
                  const { sourceItemBody } = body

                  const params: {
                    order?: GetAssetListParameters['order']
                    category?: GetAssetListParameters['category']
                  } = {}
                  if (sourceItemBody) {
                    params.order = sourceItemBody.order || undefined
                    params.category = sourceItemBody.category || undefined
                  }
                  const res = await this._getAssetList({
                    ...body,
                    ...params,
                  })
                  return {
                    data: res.data,
                    totalCount: res.count,
                  }
                }}
              />

            </Spin>

          )}
        </Spin>

      </div>
    )
  }

}
export default connector(AssetList)

